import React, { useEffect } from "react";
import { HomePageWrapper } from "./home.styles";
import SectionImportantLinks from "./sections/important-links";
import SectionQuickAccess from "./sections/quick-access";
import SectionNewsHighlights from "./sections/newsHighlights";
import SectionPublicationsTabs from "./sections/section-publications-tabs";
import { useHomeController } from "./context/home-controller";
import { useHomeState } from "./context/home-context";
import { HomeSkeleton } from "../components/shared/skeletons";
import BannerSlide from "./sections/banner-slide";
import { CustomHome, DEFAULT_NEWS_QUANTITY } from "./custom-home";
import { useGlobalState } from "../global/context/global-context";
import { HomeSectionType } from "../../model/base/response/portal-home-response";

export function HomeComponent() {
  const { loadBanners, loadNews, loadGroupedDailyOfficial, loadCategoriesWithSubcategories } = useHomeController();
  const { banners, loading, loadingNews } = useHomeState();
  // Customização carregada junto com o portal (AppInitializer); sem customização segue a home padrão
  const { portalHome } = useGlobalState();
  const customSections = portalHome?.isCustomized ? portalHome.sections || [] : [];
  const isCustomized = customSections.length > 0;

  useEffect(() => {
    const newsQuantities = customSections
      .filter((section) => section.type === HomeSectionType.Noticias)
      .map((section) => section.itemsQuantity || DEFAULT_NEWS_QUANTITY);

    loadBanners();
    loadNews(Math.max(DEFAULT_NEWS_QUANTITY, ...newsQuantities));
    loadGroupedDailyOfficial();
    loadCategoriesWithSubcategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading || loadingNews) {
    return <HomeSkeleton />;
  }

  return (
    <HomePageWrapper>
      {isCustomized ? (
        <>
          {/* Carrossel do topo (tela de Banners do APM); a seção Banners da home é banner de corpo */}
          <BannerSlide banners={banners} />
          <CustomHome sections={customSections} />
        </>
      ) : (
        <>
          <BannerSlide banners={banners} />
          <SectionQuickAccess />
          <SectionImportantLinks />
          <SectionNewsHighlights />
          <SectionPublicationsTabs />
        </>
      )}
    </HomePageWrapper>
  );
}
